import { combineReducers } from 'redux';

import advancedSettings from './advancedSettings';
import application from './application';
import chatHistory from './chatHistory';
import clientData from './clientDocs';
import currentUser from './currentUser';
import colorTheme from './colorTheme';
import constants from './constants';
import fedSentiment from './fedSentiment';
import docs from './docs';
import gptModels from './gptModels';
import gridTableAnalysis from './gridTableAnalysis';
import gridTableResults from './gridTableResults';
import infoIcon from './infoIcon';
import liveDocs from './liveDocs';
import recentDocs from './recentDocs';
import watchlist from './watchlist';
import uploadStatus from './uploadStatus';
import uploadFiles from './uploadFiles';
import flow from './flow';
import tableBuilder from './tableBuilder';

const rootReducer = combineReducers({
  application,
  advancedSettings,
  chatHistory,
  clientData,
  colorTheme,
  constants,
  currentUser,
  docs,
  flow,
  fedSentiment,
  gptModels,
  gridTableAnalysis,
  gridTableResults,
  infoIcon,
  liveDocs,
  recentDocs,
  tableBuilder,
  watchlist,
  uploadStatus,
  uploadFiles,
});

export default rootReducer;
